import Form from "@/classes/Form"
import axios from '@/util/axios'

export default {

    data() {
        return {
            stripeIntent: null,
            stripeSubmitted: false,
            stripeCardCompleted: false,
            couponApplied: null,
            couponForm: new Form({
                code: '',
            }).dontClear(),
            stripe: null,
            elements: null,
            card: null,
            stripeStyle: {
                // base: {
                //     backgroundColor: '#FCFAF5',
                //     color: '#32325d',
                //     fontFamily: 'Grotesk, helvetica',
                //     fontSize: '14px',
                // },
            },
            stripePaymentOptions: {
                applePay: false,
                googlePay: false,
                link: false,
            }
        }
    },

    created() {
        this.stripe = Stripe(config.stripeKey);
    },

    mounted() {
        this.createElements()
        this.addAlternativePaymentOptions()
    },

    methods: {

        createElements() {
            // Check that the stripe element is on the DOM
            if (!document.getElementById('stripe-card-element')) {
                console.error("Not stripe element found.")
                return
            }

            // Fetch a payment intent
            this.newStripeIntent()
            // Create a Card Input
            this.elements = this.stripe.elements();
            this.card = this.elements.create('card', {
                style: this.stripeStyle,
                hidePostalCode: false
            });
            this.card.mount('#stripe-card-element');
            this.card.addEventListener('change', event => {

                if (this.form) {
                    this.form.errors.clear()
                }

                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }

                if (event.complete) {
                    $('#submit-stripe').removeClass('disabled');
                    this.stripeCardCompleted = true
                } else {
                    $('#submit-stripe').addClass('disabled');
                    this.stripeCardCompleted = false
                }
            });

        },

        // Create a Google Pay and Apple Pay buttons.
        addAlternativePaymentOptions() {

            if(!document.getElementById('payment-request-button')){
                return;
            }

            const paymentRequest = this.stripe.paymentRequest({
                country: 'US',
                currency: 'usd',
                total: {
                    label: 'Well Travelled Subscription',
                    amount: 0,
                },
                requestPayerName: false,
                requestPayerEmail: true,
            });
            var prButton = this.elements.create('paymentRequestButton', {paymentRequest});

            paymentRequest.canMakePayment().then(result => {

                console.log(result)

                if (result) {

                    this.stripePaymentOptions.applePay = result.applePay
                    this.stripePaymentOptions.googlePay = result.googlePay
                    this.stripePaymentOptions.link = result.link

                    $('#reg-alt-cc .start-trial').hide();
                    $('.step--payment__form .or-divider').show();

                    prButton.mount('#payment-request-button');

                    paymentRequest.on('paymentmethod', (ev) => {
                        if (ev.paymentMethod.id) {
                            //         $('#payment-request-button').hide();
                            //         $('#reg-alt-cc .start-trial').show().addClass('submitting').html('Submitting...');
                            this.stripeTokenHandler(ev.paymentMethod.id);
                        } else {
                            //         $('#payment-request-button').show();
                            //         $('#reg-alt-cc .start-trial').hide().removeClass('submitting').html('Start My Free Trial');
                        }
                        ev.complete('success');
                    });
                } else {
                    this.stripePaymentOptions.applePay = false
                    this.stripePaymentOptions.googlePay = false
                    $('.credit-card-tab.apple-pay, .credit-card-tab.google-pay').remove();
                    $('.step--payment__form .or-divider').hide();
                    document.getElementById('payment-request-button').style.display = 'none';
                }
            });
        },

        submitPaymentIntent() {

            this.stripeSubmitted = true

            this.stripe.confirmCardSetup(this.stripeIntent.client_secret, {
                payment_method: {card: this.card}
            }).then((result) => {
                this.stripeSubmitted = false
                if (result.error) {
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;
                } else {
                    this.stripeTokenHandler(result.setupIntent.payment_method);
                }
            });
        },

        addPromo() {
            this.couponApplied = null
            this.couponForm.post(`/verify-coupon`)
                .then((response) => {
                    this.couponApplied = response.coupon
                    this.couponAddedHandler(response.coupon)
                    $('.promo-code-row').slideUp();
                    $('.promo-code-final-row').slideDown({
                        start: function () {
                            $(this).css({
                                display: "flex"
                            })
                        }
                    });
                })
                .catch(errors => {

                })
        },

        removePromo() {
            this.couponForm.code = '';
            this.couponApplied = null
            this.couponRemovedHandler()
            $('.promo-code-final-row').slideUp();
            $('.promo-code-button-row').slideDown({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
        },

        couponAddedHandler() {
            // To be implemented on main Components
        },

        couponRemovedHandler() {
            // To be implemented on main Components
        },

        newStripeIntent() {
            axios.post(`/payment-intent`)
                .then(response => {
                    this.stripeIntent = response.data.intent
                })
        },

        toggle() {
            this.isOpen = !this.isOpen
        }
    },
}
